this.inBrowser=inBrowser;
